var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamcity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 105,
    viewBox: "0 0 105 105",
    width: 105,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 41.73,
    x2: 33.52,
    y1: 62.97,
    y2: 38.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07c3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b57ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 38.93,
    x2: 68.35,
    y1: 71.21,
    y2: 56.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07c3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009ae5"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 76.23,
    x2: 27.55,
    y1: 56.76,
    y2: 20.01
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009ae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b57ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 25.79,
    x2: 58.95,
    y1: 82.03,
    y2: 14.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#07c3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#3bea62"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.94 87.52-20.12-52.91a22.14 22.14 0 0 1 20.08-30.01 22.13 22.13 0 0 1 21.6 15.24l17.61 53.79c3.55 10.85-35.19 24.37-39.17 13.89z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m89.31 70.73-49.31 26.67a23.85 23.85 0 0 1 -33.1-11.2 23.9 23.9 0 0 1 12.84-32l52-21a20.69 20.69 0 0 1 24.55 7.12 20.76 20.76 0 0 1 -6.98 30.41z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m70.68 71.19-50.92-24.61a22.16 22.16 0 0 1 -6-35.62 22.08 22.08 0 0 1 26.16-3.78l49.7 27a20.82 20.82 0 0 1 8.46 28 20.76 20.76 0 0 1 -27.4 9.01z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.58 98.33a24.1 24.1 0 0 1 -8.58-37.27l43.08-52.06a12 12 0 0 1 14.19-3.3 12.05 12.05 0 0 1 6.41 15l-22.46 63.73a24 24 0 0 1 -32.64 13.9z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 22.5h60v60h-60z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.98 71.16h22.5v3.75h-22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.03 34.49h-6.87v-4.58h18.7v4.58h-6.87v17.99h-4.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.73 41.26v-.06a11.46 11.46 0 0 1 11.77-11.67 11.64 11.64 0 0 1 8.9 3.47l-3.16 3.64a8.34 8.34 0 0 0 -5.78-2.55c-3.8 0-6.54 3.16-6.54 7v.07c0 3.87 2.68 7.09 6.54 7.09 2.58 0 4.16-1 5.94-2.64l3.16 3.19a11.55 11.55 0 0 1 -9.26 4 11.39 11.39 0 0 1 -11.57-11.54"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamcity);
export default __webpack_public_path__ + "static/media/teamcity.77785d04942b078ef90f9a5a6d1d16ba.svg";
export { ForwardRef as ReactComponent };